import { motion } from "framer-motion";
import { X, Ruler } from "lucide-react";

const CHART = [
    { size: "28", waist: "28–29", hip: "36–37", thigh: "21–22", inseam: "30" },
    { size: "30", waist: "30–31", hip: "38–39", thigh: "22–23", inseam: "31" },
    { size: "32", waist: "32–33", hip: "40–41", thigh: "23–24", inseam: "32" },
    { size: "34", waist: "34–35", hip: "42–43", thigh: "24–25", inseam: "32" },
    { size: "36", waist: "36–37", hip: "44–45", thigh: "25–26", inseam: "33" },
    { size: "38", waist: "38–39", hip: "46–47", thigh: "26–27", inseam: "33" },
];

export default function SizeGuide({ selected, onClose }) {
    return (
        <div data-testid="size-guide-modal" className="fixed inset-0 z-[110] grid place-items-center p-4">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                onClick={onClose}
                className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            />
            <motion.div
                initial={{ opacity: 0, y: 30, scale: 0.97 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="relative z-10 w-full max-w-lg border border-white/10 bg-coal"
            >
                <div
                    className="denim-bg relative flex items-center justify-between overflow-hidden border-b border-white/10 px-6 py-4"
                    style={{ backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
                >
                    <div className="absolute inset-0 bg-obsidian/60" />
                    <p className="relative z-10 flex items-center gap-3 font-display text-lg font-bold uppercase text-ink">
                        <Ruler size={18} className="text-gold" /> Size Guide
                    </p>
                    <button
                        data-testid="size-guide-close"
                        onClick={onClose}
                        aria-label="Close size guide"
                        className="rivet relative z-10 grid h-9 w-9 place-items-center rounded-full"
                    >
                        <X size={14} className="relative z-10 text-[#3c1e06]" />
                    </button>
                </div>
                <div className="p-6">
                    <div className="overflow-x-auto" data-testid="size-guide-table">
                        <table className="w-full text-left text-sm">
                            <thead>
                                <tr className="text-[10px] font-mono uppercase tracking-[0.2em] text-gold">
                                    <th className="pb-3 pr-4 font-medium">Size</th>
                                    <th className="pb-3 pr-4 font-medium">Waist</th>
                                    <th className="pb-3 pr-4 font-medium">Hip</th>
                                    <th className="pb-3 pr-4 font-medium">Thigh</th>
                                    <th className="pb-3 font-medium">Inseam</th>
                                </tr>
                            </thead>
                            <tbody className="font-mono text-ink">
                                {CHART.map((row) => {
                                    const active = selected === row.size;
                                    return (
                                        <tr
                                            key={row.size}
                                            data-testid={`size-guide-row-${row.size}`}
                                            className={`border-t border-white/10 ${active ? "bg-gold/10 text-gold" : "text-mute"}`}
                                        >
                                            <td className="py-2.5 pr-4 font-semibold">
                                                {active ? "▸ " : ""}
                                                {row.size}
                                            </td>
                                            <td className="py-2.5 pr-4">{row.waist}"</td>
                                            <td className="py-2.5 pr-4">{row.hip}"</td>
                                            <td className="py-2.5 pr-4">{row.thigh}"</td>
                                            <td className="py-2.5">{row.inseam}"</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <p className="mt-5 text-xs leading-relaxed text-mute">
                        Garment measurements in inches. URWAN denim is cut for a natural fit — between
                        sizes, size down for a sharper silhouette.
                    </p>
                </div>
            </motion.div>
        </div>
    );
}
